// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/infinity.js';

import { paths } from '../generated/infinity';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('infinity', Original, paths);
